import { Filter } from "@bmi-digital/components/filters";
import { sanitiseQueryString } from "../../../utils/elasticSearch";

export const constructFiltersQuery = (filters: readonly Filter[]) => {
  const selectedFilters = filters.filter((filter) => filter.value?.length);

  if (!selectedFilters.length) {
    return [];
  }

  return selectedFilters.map((filter) => ({
    terms: {
      [`${filter.filterCode}.keyword`]: filter.value
    }
  }));
};

export const constructSearchQuery = (searchQuery: string) => ({
  query_string: {
    query: searchQuery ? `*${sanitiseQueryString(searchQuery)}*` : "*",
    analyze_wildcard: true,
    fields: [
      "courseCode", //Returns a partial match. When at least one word matches
      "courseCode.keyword^2", //Returns an exact match. When the search query completely matches the field
      "courseName",
      "courseName.keyword^2"
    ]
  }
});
